import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAppointmentSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type GetAppointmentSubscription = { __typename?: 'subscription_root', appointments_by_pk?: { __typename?: 'appointments', id: number, type: string, source: string, appointment_time?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_at_pickup: boolean, customer_id: number, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_color?: string | null, vehicle_vin?: string | null, status: string, move_id?: number | null, offered_at?: string | null, offered_by?: string | null, createdat: string, createdby: string, config?: object | null, driver_notes?: string | null, ro_number?: string | null, payment_failure_reason?: string | null, payment_transaction_id?: string | null, customer: { __typename?: 'customers', name?: string | null, config?: object | null, organization?: { __typename?: 'organizations', config?: object | null } | null }, delivery?: { __typename?: 'locations', id: number, address?: string | null, name?: string | null } | null, pickup?: { __typename?: 'locations', id: number, address?: string | null, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, customer_id: number, status?: string | null, enriched_at?: string | null, route_polyline?: string | null, description?: string | null, favorite: boolean, delivery_inspection_sec?: number | null, distance_miles?: number | null, duration_sec?: number | null, pickup_inspection_sec?: number | null, return_ride_wait_sec?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, nickname?: string | null, address?: string | null, email?: string | null, phone?: string | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, nickname?: string | null, address?: string | null, email?: string | null, phone?: string | null }, inverse?: { __typename?: 'lanes', id: number, customer_id: number, status?: string | null, enriched_at?: string | null, route_polyline?: string | null, distance_miles?: number | null, duration_sec?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null } } | null } | null, move?: { __typename?: 'moves', id: number, status?: string | null } | null, service_orders: Array<{ __typename?: 'service_orders', id: number, status: string, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_vin?: string | null, service_description: string, started_at?: string | null, completed_at?: string | null, stop: { __typename?: 'mobility_stops', id: number, stop_order: number, status: string, address?: string | null, run: { __typename?: 'mobility_runs', id: number, status: string, departure_time?: string | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string }>, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string } | null } | null } } }>, workflowset: { __typename?: 'workflowsets', delivery_workflow_id: number, pickup_workflow_id: number, description: string, id: number, name: string, public: boolean, sla?: { __typename?: 'slas', description?: string | null, duration_hrs?: number | null, id: number, label: string, public: boolean } | null } } | null };


export const GetAppointmentDocument = gql`
    subscription GetAppointment($id: bigint!) {
  appointments_by_pk(id: $id) {
    id
    type
    source
    appointment_time
    consumer_name
    consumer_phone
    consumer_at_pickup
    customer_id
    vehicle_make
    vehicle_model
    vehicle_year
    vehicle_color
    vehicle_vin
    status
    move_id
    offered_at
    offered_by
    createdat
    createdby
    config
    driver_notes
    ro_number
    payment_failure_reason
    payment_transaction_id
    customer {
      name
      config
      organization {
        config
      }
    }
    delivery {
      id
      address
      name
    }
    pickup {
      id
      address
      name
    }
    lane {
      id
      customer_id
      status
      enriched_at
      route_polyline
      description
      favorite
      pickup {
        id
        name
        nickname
        address
        email
        phone
      }
      delivery {
        id
        name
        nickname
        address
        email
        phone
      }
      delivery_inspection_sec
      distance_miles
      duration_sec
      pickup_inspection_sec
      return_ride_wait_sec
      inverse {
        id
        customer_id
        status
        enriched_at
        route_polyline
        distance_miles
        duration_sec
        pickup {
          id
          name
          address
        }
        delivery {
          id
          name
          address
        }
      }
    }
    move {
      id
      status
    }
    service_orders {
      id
      status
      vehicle_make
      vehicle_model
      vehicle_year
      vehicle_vin
      service_description
      started_at
      completed_at
      stop {
        id
        stop_order
        status
        address
        run {
          id
          status
          departure_time
          stops(order_by: {stop_order: asc}) {
            id
            stop_order
            status
          }
          driver {
            id
            user {
              id
              display_name
            }
          }
        }
      }
    }
    workflowset {
      delivery_workflow_id
      pickup_workflow_id
      description
      id
      name
      public
      sla {
        description
        duration_hrs
        id
        label
        public
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentSubscription__
 *
 * To run a query within a React component, call `useGetAppointmentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetAppointmentSubscription, GetAppointmentSubscriptionVariables> & ({ variables: GetAppointmentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAppointmentSubscription, GetAppointmentSubscriptionVariables>(GetAppointmentDocument, options);
      }
export type GetAppointmentSubscriptionHookResult = ReturnType<typeof useGetAppointmentSubscription>;
export type GetAppointmentSubscriptionResult = Apollo.SubscriptionResult<GetAppointmentSubscription>;